import { render } from "./auditModule.vue?vue&type=template&id=a8d71164"
import script from "./auditModule.vue?vue&type=script&lang=js"
export * from "./auditModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__